<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>Disabled Locations and Links</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>

    <div *ngIf="disabledLinks.length || disabledNodes.length" class="modal-body">
        <ng-container *ngIf="disabledNodes.length">
            <h6 (click)="toggleOpenedLists('nodes')" (keydown)="toggleOpenedLists('nodes')" class="devices-list-title">
                Disabled Locations({{ disabledNodes.length }})
                <button windeActionIcon>
                    <sui-svg-icon [icon]="showNodes ? 'angle-up' : 'angle-down'" windeGrey />
                </button>
            </h6>
            <div *ngIf="showNodes" class="grid">
                <!-- BODY -->
                <div
                    *ngFor="let node of disabledNodes"
                    [ngClass]="{ 'highlight-substring--blue': selectedDisabledNodes.indexOf(node) !== -1 }"
                    class="grid-row"
                >
                    <div class="grid-row__cell">
                        <winde-node-pointer [listData]="{ nodeNames: node, placement: 'top', cropName: 20 }"></winde-node-pointer>
                    </div>
                    <div *ngIf="layers" class="grid-row__cell">{{ layers[getNodeLayerIndex(node)] }}</div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="disabledLinks.length">
            <h6 (click)="toggleOpenedLists('links')" (keydown)="toggleOpenedLists('links')" class="devices-list-title">
                Disabled Links ({{ disabledLinks.length }})
                <button windeActionIcon>
                    <sui-svg-icon [icon]="showLinks ? 'angle-up' : 'angle-down'" windeGrey />
                </button>
            </h6>
            <div *ngIf="showLinks" class="grid">
                <!-- BODY -->
                <div *ngFor="let link of disabledLinks" [ngClass]="{ 'highlight-substring--blue': link.selected }" class="grid-row">
                    <div class="grid-row__cell">
                        <winde-link-pointer
                            [linkData]="{
                                nodeFrom: link.fromNode,
                                nodeTo: link.toNode,
                                name: link.fromNode + ' - ' + link.toNode
                            }"
                        ></winde-link-pointer>
                    </div>
                    <div *ngIf="layers" class="grid-row__cell">{{ layers[link.layer] }}</div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
